import { Breadcrumbs, Link, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

interface BreadcrumbSegment {
  label: string;
  entry?: string;
  path?: string;
}

interface FilesBreadcrumbProps {
  segments: BreadcrumbSegment[];
  onNavigate: (entry?: string, path?: string) => void;
}

const FilesBreadcrumb = ({ segments, onNavigate }: FilesBreadcrumbProps) => (
  <Breadcrumbs sx={{ mb: 2 }}>
    {segments.map((segment, index) => {
      const isLast = index === segments.length - 1;
      const isHome = index === 0;

      if (isLast) {
        return (
          <Typography key={segment.label} color="text.secondary" sx={{ fontSize: 14 }}>
            {segment.label}
          </Typography>
        );
      }

      return (
        <Link
          key={segment.label}
          component="button"
          underline="hover"
          onClick={() => onNavigate(segment.entry, segment.path)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            fontSize: 14,
            fontWeight: 600,
            color: 'primary.main',
          }}
        >
          {isHome && <HomeIcon sx={{ fontSize: 18 }} />}
          {segment.label}
        </Link>
      );
    })}
  </Breadcrumbs>
);

export default FilesBreadcrumb;
